class ReadProgress extends HTMLElement {
    constructor() {
        super();

        const id = this.getAttribute('data-until') ?? 'comments';
        const padding = Number(this.getAttribute('data-padding') ?? '120');

        this._maxScrollY = document.getElementById(id).offsetTop - padding;

        addEventListener('scroll', this._onWindowScroll.bind(this));
    }

    _update() {
        const value = Math.min(scrollY / this._maxScrollY, 1);

        this.style.setProperty('--value', String(value));
    }

    _onWindowScroll() {
        this._update();
    }
}

customElements.define('read-progress', ReadProgress);
export default ReadProgress;
